"use strict";
exports.__esModule = true;
exports.fromSolanaResourcesRaw = exports.toSolanaResourcesRaw = void 0;
function toSolanaResourcesRaw(resources) {
    return {
        stakes: JSON.stringify(resources.stakes)
    };
}
exports.toSolanaResourcesRaw = toSolanaResourcesRaw;
function fromSolanaResourcesRaw(resourcesRaw) {
    return {
        stakes: JSON.parse(resourcesRaw.stakes)
    };
}
exports.fromSolanaResourcesRaw = fromSolanaResourcesRaw;
//# sourceMappingURL=serialization.js.map